import React, {Component} from 'react'
import InitialMap from './InitialMap'
import WyszukiwarkaService from "../wyszukiwarka/WyszukiwarkaService";
import moment from "moment";

export default class MapaMarcel extends Component {


    constructor(props) {
        super(props);

        this.state = {
            markers: [],
            zaIle: -1
        };

        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleMarkerClose = this.handleMarkerClose.bind(this)
    }

    handleMarkerClick(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) {
                    marker.showInfo = true
                } else {
                    marker.showInfo = false
                }
                return marker;
            }),
        })
    }

    handleMarkerClose(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) marker.showInfo = false;
                return marker;
            }),
        })
    }


    componentDidMount() {
        WyszukiwarkaService.getKonfigWartosc('interwal sek', 'Mapa')
            .then(function (response) {
                let interwal = response.data;
                let czasPobrania = JSON.parse(localStorage.getItem('marcelSiteMapAktualizacja'));
                let ostatniePobranie = czasPobrania? moment().diff(moment(czasPobrania), 'seconds') : 999;
                let zaIle = interwal - ostatniePobranie;
                this.setState({zaIle: zaIle});
                debugger;

                if (interwal > -1) {
                    if (interwal < ostatniePobranie) {
                        WyszukiwarkaService.getGdzieJestMarcel()
                            .then(function (response) {
                                this.setState({markers: response.data});
                                localStorage.setItem('marcelSiteMapAktualizacja', JSON.stringify(moment()));
                            }.bind(this)).catch(error => {
                            if (error.response.status === 500) {
                                alert("Błąd", "", 3000)
                            }
                        })
                            .catch((e) => {
                                console.log(e)
                            })
                    }
                }

            }.bind(this))
    }

    render() {
        return (
            <div style={{height: '95%'}}>
                {(this.state.zaIle > 0) && <div style={{position: 'absolute', top: '30px', color: '#ed143d'}}>Spróbuj ponownie za {this.state.zaIle}s</div>}
                <InitialMap
                    containerElement={
                        <div style={{height: '100%'}}/>
                    }
                    mapElement={
                        <div style={{height: '100%'}}/>
                    }
                    markers={this.state.markers}
                    onMarkerClick={this.handleMarkerClick}
                    onMarkerClose={this.handleMarkerClose}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/mapaMarcel/MapaMarcel.js